import { render, staticRenderFns } from "./client-login-panel.vue?vue&type=template&id=5b216d20&"
var script = {}
import style0 from "../../../assets/styles/panels/_ClientLoginPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports